var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{ref:"search",attrs:{"outline":"","hide-details":"","placeholder":"Search sessions...","prepend-inner-icon":"search","height":"40px"},on:{"change":function($event){return _vm.filterData()}},model:{value:(_vm.searchKey),callback:function ($$v) {_vm.searchKey=$$v},expression:"searchKey"}})
}
var staticRenderFns = []

export { render, staticRenderFns }